import React from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import NotInterestedIcon from '@material-ui/icons/NotInterested';
import { Modal } from '@material-ui/core';
import { MdClose } from 'react-icons/md';
import styles from './AggregateAvailableErrorPopup.module.css';

const Error = ({ error, rowDetails: unsortedRowDetails, headerDetails }) => {
    const rowDetails = unsortedRowDetails?.length
        ? [...unsortedRowDetails].sort((a, b) => a.row - b.row)
        : [];

    return (
        <div className={styles.error}>
            <div>
                <p className={styles.errorText}>
                    - {error} {headerDetails?.length > 0 && headerDetails.join(', ')}
                </p>
                {rowDetails.length > 0 && (
                    <table style={{ width: '100%', borderSpacing: 0 }}>
                        <tbody>
                            <tr className={clsx(styles.errorRow, styles.bold)}>
                                <td>Row</td>
                                <td>Asn</td>
                                <td>aggregate Part Number</td>
                            </tr>
                            {rowDetails.map(detail => {
                                return (
                                    <tr key={detail.row} className={styles.errorRow}>
                                        <td>{detail.row}</td>
                                        <td>{detail.fieldName}</td>
                                        <td>{detail.fieldValue?.trim() || '(blank)'}</td>
                                    </tr>
                                );
                            })}
                        </tbody>
                    </table>
                )}
            </div>
        </div>
    );
};

const AggregateAvailableErrorPopup = ({
    open,
    handleClose,
    errors: unsortedErrors = [],
}) => {
    const buildErrorsTextFile = errorData => {
        let text = 'Following are the errors for the uploaded file \n';

        errorData.forEach(error => {
            text += '\n';
            const headerText = error.headerDetails?.length > 0 ? error.headerDetails.join(', ') : '';
            text += ` - ${error.error} ${headerText} \n`;
            text += '\n';

            if (error.rowDetails?.length) {
                text += `\t${'Row'.padEnd(5, ' ')} ${'Where'.padEnd(
                    15,
                    ' ',
                )} ${'What'.padEnd(15, ' ')} \n`;
                error.rowDetails.forEach(detail => {
                    text += `\t${String(detail.row).padEnd(
                        5,
                        ' ',
                    )} ${detail.fieldName.padEnd(
                        15,
                        ' ',
                    )} ${detail.fieldValue?.trim().padEnd(15, ' ')}\n`;
                });
            }
            text += '\n';
            text += '\n';
        });
        return text;
    };

    const errors = [...unsortedErrors].sort((a, b) =>
        a.error.localeCompare(b.error),
    );

    return (
        <Modal
            open={open}
            onClose={handleClose}
            aria-labelledby="plan-upload-errors-modal"
            aria-describedby="modal view to show errors in plan upload file"
        >
            <div className={styles.container}>
                <div className={styles.header}>
                    <div className={styles.title}>
                        <NotInterestedIcon className={styles.icfail} />
                        <span> Aggregate Availability - {errors.length} Errors!</span>
                    </div>
                    <MdClose
                        className={styles.cancelIcon}
                        onClick={handleClose}
                        data-testid="close-upload-errors-icon"
                        role="button"
                    />
                </div>
                <div className={styles.content}>
                    <div className={styles.contentTitle}>
                        Clear following errors and try again
                        <a
                            className={styles.downloadLink}
                            href={`data:application/txt,${encodeURIComponent(
                                buildErrorsTextFile(errors),
                            )}`}
                            download="uploadFileErrors.txt"
                        >
                            (Download List here)
                        </a>
                    </div>
                    <div className={clsx(styles.errorsContainer, styles.scrollBar)}>
                        {errors.map(({ error, headerDetails, rowDetails }) => (
                            <Error
                                key={error}
                                error={error}
                                headerDetails={headerDetails}
                                rowDetails={rowDetails}
                            />
                        ))}
                    </div>
                </div>
            </div>
        </Modal>
    );
};

AggregateAvailableErrorPopup.propTypes = {
    open: PropTypes.bool,
    handleClose: PropTypes.func.isRequired,
    errors: PropTypes.arrayOf(
        PropTypes.shape({
            error: PropTypes.string.isRequired,
            headerDetails: PropTypes.arrayOf(PropTypes.string),
            rowDetails: PropTypes.arrayOf(
                PropTypes.shape({
                    row: PropTypes.number,
                    fieldName: PropTypes.string,
                    fieldValue: PropTypes.string,
                }),
            ),
        }),
    ),
};

export default AggregateAvailableErrorPopup;